module.exports = __webpack_public_path__ + "media/images/samples/infographics/info-2-ecf93dd11bb1cfedcaa396718b2c3671.jpg";